const API_BASE =
  process.env.REACT_APP_WALLET_SHARE_API_URL || 'https://api.cardclues.com';

const resolveApiUrl = (path: string): string => {
  const trimmedBase = API_BASE.replace(/\/$/, '');
  return `${trimmedBase}${path}`;
};

export interface SavedWallet {
  walletIds: string[];
  description?: string;
  createdAt: string;
}

export async function saveWallet(
  walletIds: string[],
  description?: string
): Promise<string> {
  const response = await fetch(resolveApiUrl('/saves'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      walletIds,
      description,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Wallet save failed with ${response.status}: ${errorText}`
    );
  }

  const data = (await response.json()) as { code?: string };
  if (!data?.code) {
    throw new Error('Wallet save response missing code.');
  }

  return data.code;
}

export async function fetchSavedWallet(code: string): Promise<SavedWallet> {
  const response = await fetch(resolveApiUrl(`/saves/${code}`), {
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Wallet fetch failed with ${response.status}: ${errorText}`
    );
  }

  return (await response.json()) as SavedWallet;
}

export async function submitCardRequest(
  cardName: string,
  cardLink?: string
): Promise<void> {
  const response = await fetch(resolveApiUrl('/card-requests'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      cardName,
      cardLink: cardLink || undefined,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Card request failed with ${response.status}: ${errorText}`
    );
  }
}
